<template>
  <div class="catalogue-checkbox flex items-center" v-on="triggers">
    <div id="checkboxId" class="pl-2 box rounded-sm" :class="checked ? 'checked' : 'unchecked'">
      <i v-if="checked" class="far fa-check fa-1x text-white text-12"></i>
    </div>
    <span class="capitalize cursor-pointer text-16 lg:text-14"><slot></slot></span>
    <slot name="icon"></slot>
  </div>
</template>
<script>
import CustomCheckbox from './CustomCheckbox'

export default {
  extends: CustomCheckbox,
}
</script>
